export default {
  login: {
    welcomeMsg: "Welkom! Log in",
    info: "Voer uw inloggegevens in",
    forgot: "Wachtwoord vergeten?",
    btn: "Inloggen",
    unableToLogin: "Kan niet inloggen",
  },
  forgot: {
    info_l1:
      "Voer het e-mailadres in dat aan uw account is gekoppeld. De details van het wachtwoord worden naar uw e-mailadres gestuurd.",
    info_l2:
      "Voer uw mobiele nummer in dat is gekoppeld aan het account. De details van uw wachtwoord worden naar uw mobiel gestuurd.",
    forgotQ: "Wachtwoord vergeten?",
    loginNow: "Nu inloggen",
    resetSucc: "Uw wachtwoord is succesvol gereset.",
    resetSucc_l2:
      "U kunt nu uw nieuwe wachtwoord gebruiken om in te loggen op uw account.",
    entPsw: "Voer uw nieuw wachtwoord in.",
    resetPsw: "Wachtwoord resetten",
    resendOTP: "OTP opnieuw verzenden",
    enterCorrectOTP: "Voer de juiste OTP in.",
    enterOTP: "Voer de ontvangen OTP in uw e-mail/mobiel in.",
    backToLoginPage: "Terug naar inlogpagina",
  },
  permissions: {
    savePermissions: "Rechten opslaan",
    moduleName: "Module naam",
    view: "Bekijken",
    create: "Creëren",
    update: "Bijwerken",
    delete: "Verwijderen",
    permissionsUpdated: "Rechten bijgewerkt",
    permissionsNotUpdated: "Rechten niet bijgewerkt",
    selectMembership: "Selecteer lidmaatschap",
    noPermMsg:
      "Selecteer het lidmaatschapstype met behulp van het vervolgkeuzemenu 'Lidmaatschapstype' hierboven om de rechten te zien",
    selectRoleMsg: "Selecteer de rol hierboven om de rechten weer te geven",
  },
  activationKey: {
    enterActivationKey:
      "Voer de activeringscode in om een nieuwe gebruiker te registreren",
    activationKeyRequired: "Activeringscode vereist",
    activationKeyLimit: "Minimum 15 tekens",
    countryRequired: "Landcode is verplicht",
    activationKey: "Activeringscodes",
    appointSalesManager: "Benoem verkoopmanager",
    appointManager: "MANAGER BENOEMEN",
    salesManAppSuccess: "VERKOOPMANAGER SUCCESVOL BENOEMD",
    uploadData: "UPLOAD TOEGEWEZEN GEGEVENS CSV",
    uploadUserData: "Upload gebruikersgegevensbestand",
    downloadCsv:
      "(Download het voorbeeld .csv-bestand om de structuur te volgen)",
    downloadSample: "Download voorbeeldbestand",
    dragDrop: "Sleep en zet neer of blader door uw bestand ",
    browse: "bladeren",
    yourFile: "uw bestand",
    pdfSupport: "Alleen PDF-bestanden worden ondersteund.",
    pleaseWait: "Even geduld alstublieft",
    note: "Notitie",
    incorectFileType: "Onjuist bestandstype",
    somethingWentWrong: "Er is iets misgegaan. Probeer het later opnieuw. ",
    fileUploadedSuccess: "Bestand succesvol geüpload",
    countRecords: "Aantal records tellen",
    sendNow: "NU VERZENDEN",
    fileName: "Bestandsnaam",
    assignActKey: "Activeringscodes toewijzen",
    actKeyAssSucc: "Activeringscodes succesvol toegewezen",
    viewActKey: "ACTIVERINGSCODES WEERGEVEN",
    actKeyQuota: "Activeringscodequota",
    genActKey: "Gegenereerde activeringscodes",
    remActKey: "Overgebleven activeringscodes",
    penUsed: "Ongebruikte en gebruikte codes",
    activationKeyAss: "Toegewezen activeringscodes",
    activationKeyUnass: "Niet-toegewezen activeringscodes",
    keysAct: "Geactiveerde codes",
    uploadedFiles: "Geüploade bestanden",
    generateActKey: "ACTIVERINGSCODES GENEREREN",
    showData: "Gegevens weergeven",
    noDataFound: "Geen gegevens gevonden",
    pleaseGenKey: 'Genereer activeringscodes met "Activeringscodes genereren"',
    noActKey: "Geen activeringscodes gegenereerd",
    buttonAbv: "bovenste knop",
    numberOfActKey: "Aantal activeringscodes",
    membershipRole: "Lidmaatschapsrol",
    membershipPlan: "Lidmaatschapsplan",
    comments: "Opmerkingen",
    genKeys: "CODES GENEREREN",
    keysNum: "Aantal codes",
    phoneNumber: "Telefoonnummer",
    keysStatus: "Code status",
    ActivationKeysList: "Lijst met activeringscodes",
    back: "TERUG",
    usingActKeys: 'Genereer activeringscodes met "Activeringscodes genereren""',
    pleaseGenActKeyss: "Genereer activeringscodes",
    clearAllFilters: "ALLE FILTERS WISSEN",
    salesManager: "Verkoopmanager",
    clearAll: "ALLES WISSEN",
    generatedBy: "Gegenereerd door",
    numberOfKeys: "Aantal codes",
    action: "Actie",
    viewAllUplFiles: "Alle geüploade bestanden bekijken",
    bulkUploadUsers: "Meeste gebruikers uploaden",
    noActivationKeyFound: "Geen activeringscodes gevonden",
    pleaseCreateAdminRole: "Maak de beheerdersrol aan met behulp van de",
    btnCreateAdmin: 'knop "Beheerdersrol maken" hierboven',
    donwloadAsCsv: "Downloaden als CSV",
    donwloadAsPdf: "Downloaden als PDF",
    assignSalesManager: "Verkoopmanager toewijzen",
    shareViaEmail: "Delen via e-mail",
    sendEmail: "E-MAIL VERZENDEN",
    emailSend: "E-MAIL SUCCESVOL VERZONDEN",
    donwload: "Downloaden",
    deleteFile: "Bestand verwijderen",
    filterBy: "Filteren op",
    memberRequired: "Lidmaatschap is vereist",
    memberRoleRequired: "Lidmaatschapsrol is vereist",
    memberKeyRequired: "Sleutelwaarde is vereist",
    enterComment: "Voer hier uw commentaar in",
    invalidFileData: "De activeringscodegegevens in het bestand zijn ongeldig",
  },
  profileSetting: {
    defaultOrganizationOTPForSignUp: "Standaard organisatie-OTP voor aanmelden",
    whoreceivedthealert: "Ontvanger van de waarschuwing",
    otp: "OTP",
    passwordReuse: "Hergebruik van wachtwoord",
    organizationSplashScreen: "Organisatiesplashscreen",
    organizationSplash1: "Organisatiesplashscreen",
    generateOtp: "Genereer OTP",
    addAnother: "Voeg een ander toe",
    dragAndDropOr: "Slepen en neerzetten of bladeren",
    browse: "Bladeren",
    save: "Opslaan",

    profileAuthSettings: "Profielauthenticatie-instellingen",
    changeSettings: "Instellingen wijzigen",
    loginLogoutSettings: "Inlog-/uitloginstellingen",
    autoLogout: "Automatisch uitloggen",
    unsuccAtmp: "Mislukte inlogpogingen",
    unsuccLoginLock: "Vergrendeltijd na mislukte inlogpogingen",
    pswCrisetup: "Wachtwoordparameters instellingen",
    pswLength: "Wachtwoordlengte",
    noOfUniquePsw: "Aantal vereiste unieke wachtwoorden",
    maxPswAge: "Maximale leeftijd van het wachtwoord",
    AccRangeOfchars: "Acceptabel bereik van tekens",
    upperCase: "Hoofdletters",
    lowerCase: "Kleine letters",
    numbers: "Cijfers",
    specialChars: "Speciale tekens",
    settingsUpdated: "Instellingen bijgewerkt",
    settingsNotUpdated: "Instellingen niet bijgewerkt",
    organization: "Organisatie",
    organizationLogo: "Organisatie Logo",
    organizationSplash: "Organisatie Splash-scherm",
    defaultOtpOrganization: "Standaard organisatie-OTP voor aanmelding",
    alertCrop: "Alertgewas",
    alertCropInfo: "Alertgewas waarvoor u meldingen ontvangt",
    alertCountry: "Alertland",
    alertCountryInfo: "Alertland waarvoor u meldingen ontvangt",
    alertRegion: "Alertregio",
    alertRegionInfo:
      "Alertregio van het geselecteerde land waarvoor u meldingen ontvangt",
    alertMaximum: "Maximale hoeveelheid",
    alertMaximumInfo:
      "Maximale hoeveelheid toegestaan waarvoor u meldingen ontvangt",
    selectCrop: "Selecteer gewas",
    alertFor: "Selecteer wie de melding zal ontvangen",
    alertAdmin: "Melding voor de beheerder",
    alertFarmer: "Melding voor de boer",
    cropsHarvestAlert: "Oogstmeldingen van gewassen",
    selectCountry: "Selecteer land",
    selectCountryInfo: "Kies de geografische locatie die van toepassing is op de beoordeling.",
    maxAllowed: "Maximaal toegestaan / ha / jr",
    maxProduction: "Maximale productie / hectaren / jaar",
    crop: "Gewassen",
    alert: "Melding",
    selectCountryError: "Selecteer eerst het land",
    unitError: "Stel de maximale productie en eenheid in",
  },
  adminRoles: {
    adminRoles: "Beheerdersrollen",
    roleName: "Rolnaam",
    description: "Omschrijving",
    viewPermissions: "Bekijk machtigingen",
    createAdminRole: "BEHEERDERSROL AANMAKEN",
    enterDesHere: "Voer hier uw omschrijving in",
    deleteRole: "Rol verwijderen",
    deleteMsg: "Weet u zeker dat u de beheerdersrol wilt verwijderen?",
    roleReq: "Rolnaam is verplicht",
    roleLimit: "Rolnaam moet minder dan 15 tekens bevatten",
    desReq: "Omschrijving is verplicht",
    desLimit: "Omschrijving moet 40 tekens of minder bevatten",
    roleSuccess: "Beheerdersrol succesvol aangemaakt",
    editAdminRole: "Beheerdersrol bewerken",
    roleUpdated: "Rol bijgewerkt",
    noRole: "Geen beheerdersrol gevonden",
    noRoleMsg:
      "Maak de beheerdersrol aan met de knop 'Beheerdersrol aanmaken' hierboven",
  },
  roleRequest: {
    roleRequest: "Rolverzoek",
    userRole: "Gebruikersrol",
    approve: "Goedkeuren",
    reject: "Afkeuren",
    username: "Gebruikersnaam",
    email: "E-mail",
    phone: "Telefoon",
    roleAssigned: "Toegewezen rol",
    roleRequested: "Aangevraagde rol",
    requestedDate: "Aangevraagde datum",
    updateRoleRequest: "Rolverzoek bijwerken",
    message: "Bericht",
    update: "Bijwerken",
  },
  userslist: {
    createNewUser: "Maak een nieuwe gebruiker aan",
    chooseCreateType: "Kies een van de volgende opties:",
    addNewUser: "Nieuwe gebruiker toevoegen",
    editUser: "Gebruiker bewerken",
    addNewAdmin: "Nieuwe beheerder toevoegen",
    userLoading: "Gebruikers laden... Even geduld alstublieft",
    noUser: "GEEN GEBRUIKER BESCHIKBAAR",
    extendVal: "GELDIGHEID VERLENGEN",
    extendReason: "Reden voor verlenging",
    extendReasonMsg:
      "Specificeer de reden voor de verlenging van het lidmaatschap",
    exportAsCSV: "EXPORTEREN ALS CSV",
    membershipType: "Type lidmaatschap",
    membershipValidity: "Geldigheid lidmaatschap",
    regionState: "Regio/Provincie",
    cityTown: "Stad/Dorp",
    clearAll: "ALLES WISSEN",
    search: "ZOEKEN",
    familyTribe: "Voer uw familie-/stamnaam in",
    enterWebsite: "Voer de website in",
    registrationDate: "Registratiedatum",
    single: "Alleenstaand",
    multiple: "Meervoudig",
    user: "Gebruiker",
  },
  addEdituser: {
    firstNameRequired: "Voornaam is verplicht",
    firstNameOllyAlpha: "Voornaam mag alleen letters bevatten",
    firstNameLimit: "Voornaam moet minder dan 50 tekens bevatten",
    lastNameRequired: "Achternaam is verplicht",
    lastNameOllyAlpha: "Achternaam mag alleen letters bevatten",
    lastNameLimit: "Achternaam moet minder dan 50 tekens bevatten",
    emailReuired: "E-mail is verplicht",
    emailInvalid: "Ongeldig e-mailformaat.",
    mobileRequired: "Mobiel nummer is verplicht",
    mobileLimit: "Mobiel nummer moet minder dan 15 cijfers bevatten",
    invalidMobile: "Ongeldig mobiel nummerformaat.",
    emailExistAlready: "Gebruiker bestaat al met dit e-mailadres.",
    mobileExistAlready: "Gebruiker bestaat al met dit mobiele nummer.",
    pswRequired: "Wachtwoord is verplicht",
    deptRequired: "Afdeling is verplicht",
    roleRequired: "Rol is verplicht",
    countryRequired: "Landcode is verplicht",
    userUpdated: "Gebruiker bijgewerkt",
    userNotUpdated: "Gebruiker niet bijgewerkt",
    activateAct: "Account activeren",
    deactivateAct: "Account deactiveren",
    userActivated: "Gebruiker geactiveerd",
    userDeactivated: "Gebruiker gedeactiveerd",
    deactivateUser: "Gebruiker deactiveren",
    deactivateMsg:
      "Weet u zeker dat u de status van de gebruiker wilt wijzigen?",
    userAdded: "Gebruiker toegevoegd",
    userNotAdded: "Gebruiker niet toegevoegd",
    facilityPicture: "Faciliteitsafbeelding",
    editAppUser: "Bewerk app-gebruiker",
    validityUpTo: "Geldig Tot",
    roleEdited: "Rol Bewerkt",
    addDepartment: "Afdeling Toevoegen",
    editDepartment: "Afdeling Bewerken",
    department: "Afdeling",
    noDepartment: "Geen Afdeling",
    departmentNameRequired: "Afdelingsnaam is verplicht",
    departmentAdded: "Afdeling Toegevoegd",
    departmentEdited: "Afdeling Bewerkt",
    eoriNumberRequired: "EORI-nummer vereist",
    eoriIsNumber: "EORI moet een nummer zijn",
    addNewSupplier: "Nieuwe Leverancier Toevoegen",
    addNewProducer: "Nieuwe Producent Toevoegen",
    addNewOperator: "Nieuwe Operator Toevoegen",
    eoriNumber: "EORI-nummer",
  },
  membership: {
    remainingDays: "Resterende dagen",
    type: "Lidmaatschapstype",
    validity: "Geldigheid lidmaatschap",
    validityLength: {
      custom: "Aangepast",
      expired: "Verlopen",
      oneTo8Months: "1-8 maanden",
      lessThan1Month: "Minder dan 1 maand",
      moreThan1Month: "Meer dan 1 jaar",
      sixTo12Months: "6-12 maanden",
    },
  },
  membershipplanSection: {
    defaultPlan: "Standaardplan",
    planType: "Soort plan",
    planDuration: "Duur van het plan",
    planFee: "Planvergoeding",
    satelliteReport: "Satellietrapporten",
    advanceReport: "GEAVANCEERD RAPPORT",
    addMembership: "Lidmaatschap toevoegen",
    addMembershipPlan: "Lidmaatschapsplan toevoegen",
    accessSetelite: "Toegang tot satellietrapporten (set van 5 rapporten)",
    accessAdvanceReport: "Toegang tot geavanceerde rapporten",
    memPlanReq: "Lidmaatschapsplan is verplicht",
    memPlanReqLimit: "Lidmaatschapsplan moet minder dan 20 tekens bevatten",
    SatelliteReq: "Satellietrapport is verplicht",
    advancedReportReq: "Geavanceerd rapport is verplicht",
    durationReq: "Duur van het lidmaatschap is verplicht",
    feeReq: "Planvergoeding is verplicht",
    cantLesThenZero: "Mag niet minder dan 0 zijn",
    roleReq: "Gebruikersrol is verplicht",
    accessToDeforestationReport:
      "Toegang tot ontbossingsrapporten (per gebruiker)",
  },
  statusItems: {
    closed: "Gesloten",
    open: "Open",
  },
  orderByItems: {
    all: "Alles",
    dateAscending: "Datum oplopend",
    dateDescending: "Datum aflopend",
    dueDate: "Vervaldatum",
    high: "Hoog",
    low: "Laag",
    medium: "Gemiddeld",
  },
  ownershipTypes: {
    EXW: "EXW (Af Fabriek)",
    FCA: "FCA (Vrij Vervoerder)",
    CPT: "CPT (Vrachtvrij Tot)",
    CIP: "CIP (Vracht en Verzekering Betaald Tot)",
    DAP: "DAP (Geleverd op Plaats)",
    DPU: "DPU (Geleverd op Plaats Gelost)",
    DDP: "DDP (Geleverd Rechten Betaald)",
    FAS: "FAS (Vrij Langs Schip)",
    FOB: "FOB (Vrij Aan Boord)",
    CFR: "CFR (Kosten en Vracht)",
    CIF: "CIF (Kosten, Verzekering en Vracht)",
  },
};
